import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LovValuesSelectFilterModule} from '../../../../../common/lov/lov-value/api/component/lov-values-select-filter/lov-values-select-filter.module';
import {DocumentFormatsSelectFilterModule} from '../document-formats-select-filter/document-formats-select-filter.module';
import {FormFieldModule} from '../../../../../core/component/form-field/form-field.module';
import {DocumentCreateFormComponent} from './document-create-form.component';
import {FileUploadModule} from '../../../../../../components/common/file-upload/file-upload.module';
import {
    LovValueSelectFilterModule
} from '../../../../../common/lov/lov-value/api/component/lov-value-select-filter/lov-value-select-filter.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        FileUploadModule,
        LovValuesSelectFilterModule,
        DocumentFormatsSelectFilterModule,
        FormFieldModule,
        LovValueSelectFilterModule
    ],
    declarations: [
        DocumentCreateFormComponent,
    ],
    exports: [
        DocumentCreateFormComponent
    ]
})
export class DocumentCreateFormModule {
}
